export default __webpack_public_path__ + "static/media/bg@2x.87733fbf.webp";